import React from 'react';
import { Settings, Key, Code2, FileSearch } from 'lucide-react';
import ConfigCard from '../ConfigCard';
import AdminUsersCard from '../AdminUsersCard';
import PortalGroupsCard from '../PortalGroupsCard';
import WorkerCostDigestCard from '../WorkerCostDigestCard';

const SystemAdminTab = ({ configData, cardProps }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 gap-6">
      <AdminUsersCard />
      <PortalGroupsCard />
      <WorkerCostDigestCard />
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="System Settings" icon={Settings}
        items={configData.systemSettings}
        category="systemSettings"
        fields={['value']}
      />
      <ConfigCard {...cardProps} title="Integration Keys" icon={Key}
        items={configData.integrationKeys}
        category="integrationKeys"
        fields={['key_type', 'expires_at']}
      />
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ConfigCard {...cardProps} title="Custom Fields" icon={Code2}
        items={configData.customFields}
        category="customFields"
        fields={['model_name', 'field_type', 'required']}
      />
      <ConfigCard {...cardProps} title="Audit Logging Configs" icon={FileSearch}
        items={configData.auditConfigs}
        category="auditConfigs"
        fields={['model_name', 'log_level', 'retention_days']}
      />
    </div>
  </div>
);

export default SystemAdminTab;
